import { ColumnTypeService } from '@import/services/column-type/column-type.service';
import { ImportIntegrationService } from '@import/services/integration/import-integration.service';
import { EmployeeRowAndColumnService } from '@import/services/row-and-column/employee-row-and-column.service';
import { RowAndColumnService } from '@import/services/row-and-column/row-and-column.service';
import { ColumnRequiredService } from './column-required.service';
import { EmployeeHumiColumnService } from './column-type/employee-humi-column.service';
import { CustomFieldsService } from './custom-fields.service';
import { ReviewErrorService } from './review-error.service';
import { HumiColumnSmartMatchingService } from './row-and-column/humi-column-smart-mapping.service';

/* These will automatically be provided in the module */
const Services = [
    ColumnRequiredService,
    CustomFieldsService,
    EmployeeHumiColumnService,
    EmployeeRowAndColumnService,
    HumiColumnSmartMatchingService,
    ReviewErrorService,
    ImportIntegrationService,
];

export {
    ColumnRequiredService,
    ColumnTypeService,
    CustomFieldsService,
    EmployeeHumiColumnService,
    EmployeeRowAndColumnService,
    HumiColumnSmartMatchingService,
    ImportIntegrationService,
    ReviewErrorService,
    RowAndColumnService,
    Services,
};
